<div class="dialog">
  <div class="actions">
    <opac-button *ngIf="helpUrl()" [ariaLabel]="'tooltip.help' | translate" [opacTooltip]="'tooltip.help' | translate" (click)="openHelp()">
      <opac-icon icon="help" slot="only-icon"></opac-icon>
    </opac-button>

    <opac-button *ngIf="!disabledClose()" [ariaLabel]="'general.close' | translate" [opacTooltip]="'general.close' | translate" (click)="closeDialog()">
      <opac-icon icon="close" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <app-login *ngIf="loginScreen() === 'login'"></app-login>
  <app-signup *ngIf="loginScreen() === 'signup'"></app-signup>
  <app-forgot-password *ngIf="loginScreen() === 'forgot-password'"></app-forgot-password>
  <app-signup-code *ngIf="loginScreen() === 'signup-code'"></app-signup-code>
  <app-guest *ngIf="loginScreen() === 'guest'"></app-guest>
</div>
